import { useState } from 'react';
import AuthLayout from '../_layouts/auth';
import { Input, Button, Text, Link as LinkMD } from 'mondrian-react';
import { Auth } from 'aws-amplify';
import { useLoader } from '../../hooks/loader';
import { Link, useHistory } from 'react-router-dom';
import { useToast } from '../../hooks/toast';
import styles from './styles.module.css';

/* function verifyAuthorizedEmailDomains(email) {
  const verify = email.substring(email.indexOf('@') + 1);

  let authorized;

  switch (verify) {
    case 'claro.com.br':
      authorized = true;
      break;
    case 'globalhits.com.br':
      authorized = true;
      break;
    case 'nextel.com.br':
      authorized = true;
      break;
    case 'embratel.com.br':
      authorized = true;
      break;

    default:
      authorized = false;
      break;
  }

  return authorized;
} */

function Register() {
  const history = useHistory();
  const { setLoading } = useLoader();
  const [step, setStep] = useState(1);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [confirmEmail, setConfirmEmail] = useState('');
  const [password, setPassword] = useState('');
  const [code, setCode] = useState();
  const [inputEmailError, setInputEmailError] = useState(false);
  const [inputEmailErrorMessage, setInputEmailErrorMessage] = useState('');
  const [inputPasswordError, setInputPasswordError] = useState(false);
  const [inputPasswordErrorMessage, setInputPasswordErrorMessage] = useState();
  const [inputCodeError, setInputCodeError] = useState(false);
  const [inputCodeErrorMessage, setInputCodeErrorMessage] = useState('');
  const { addToast } = useToast();

  async function lazyState() {
    return;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();

    setLoading(true);

    await lazyState();
    setInputEmailError(false);
    setInputPasswordError(false);

    if (email !== confirmEmail) {
      setInputEmailErrorMessage('Os e-mails precisam ser iguais.');
      setInputEmailError(true);
      setLoading(false);
      return addToast({
        type: 'error',
        title: 'Os e-mails precisam ser iguais.',
        description: 'Verifique E-mail e Confirmar E-mail e tente novamente.',
      });
    }

    if(
      !email.match(/@claro.com.br$/) &&
      !email.match(/@globalhitss.com.br$/) &&
      !email.match(/@embratel.com.br$/)
    ) {
      setInputEmailErrorMessage('Acesso externo restrito.');
      setInputEmailError(true);
      setLoading(false);
      return addToast({
        type: 'error',
        title: 'Acesso externo restrito.',
        description: 'Utilize seu e-mail corporativo.',
      });
    }

    /* if (!verifyAuthorizedEmailDomains(email)) {
      setInputEmailErrorMessage('Domínio de e-mail não autorizado.');
      setInputEmailError(true);
      setLoading(false);

      return addToast({
        type: 'error',
        title: 'Domíno de e-mail não autorizado!',
        description:
          'Para autorizar, entre em contato com debora.doimo@claro.com.br.',
      });
    } */

    Auth.signUp({
      username: email,
      password,
      attributes: {
        name,
      },
    })
      .then(() => {
        setLoading(false);
        setStep(2);

        document.getElementById('CardHeader').style.display = 'none';
      })
      .catch((error) => {
        console.dir(error);

        if (error.code === 'UsernameExistsException') {
          setInputEmailErrorMessage(
            'Já existe uma conta com o e-mail fornecido.',
          );
          setInputEmailError(true);
          addToast({
            type: 'error',
            title: 'Erro de validação!',
            description: 'Já existe uma conta com o e-mail fornecido.',
          });
        }

        if (error.code === 'InvalidPasswordException') {
          setInputPasswordErrorMessage('Senha muito fraca.');
          setInputPasswordError(true);
          addToast({
            type: 'error',
            title: 'Erro de validação!',
            description:
              'A senha precisa ter no mínimo 8 caracteres. Letras maiúsculas, minúsculas e caracter especial.',
          });
        }

        setLoading(false);
      });
  };

  const handleSubmitConfirmationSignUp = (event) => {
    event.preventDefault();

    setLoading(true);
    setInputCodeError(false);

    try {
      Auth.confirmSignUp(email, code)
        .then(() => {
          addToast({
            type: 'info',
            title: 'Cadastro realizado!',
            description: 'Você já pode realizar o login.',
          });
          setLoading(false);
          return history.push('/login');
        })
        .catch((error) => {
          console.log(error);

          if (error.code === 'CodeMismatchException') {
            setInputCodeErrorMessage('Código de verificação inválido.');
            setInputCodeError(true);

            addToast({
              type: 'error',
              title: 'Erro de validação!',
              description:
                'Verifique o código enviado por email e digite novamente.',
            });

            setLoading(false);
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleResendSignUp = () => {
    setLoading(true);
    setCode('');
    setInputCodeError(false);
    setInputCodeErrorMessage('');

    try {
      Auth.resendSignUp(email);

      addToast({
        type: 'info',
        title: 'Código reenviado!',
        description: 'Verifique seu email e insira o novo código.',
      });

      setLoading(false);
    } catch (error) {
      console.log(error);

      setLoading(false);
    }
  };

  return (
    <AuthLayout noLink>
      {step === 1 && (
        <form onSubmit={handleSubmit} autoComplete="new-password">
          <div className={styles.FormInput}>
            <Input
              required
              text
              name="name"
              onChange={(e) => setName(e.target.value)}
            >
              Nome Completo
            </Input>
          </div>
          <div className={styles.FormInput}>
            <Input
              required
              email
              name="email"
              onChange={(e) => setEmail(e.target.value)}
              hasError={inputEmailError ? true : false}
              errorMessage={
                inputEmailErrorMessage ? inputEmailErrorMessage : ''
              }
              parentClassName={inputEmailError && 'mdn-Input--attentionField'}
              value={email}
              autoComplete="new-password"
            >
              E-mail
            </Input>
          </div>
          <div className={styles.FormInput}>
            <Input
              required
              email
              name="confirm-email"
              onChange={(e) => setConfirmEmail(e.target.value)}
              hasError={inputEmailError ? true : false}
              errorMessage={
                inputEmailErrorMessage ? inputEmailErrorMessage : ''
              }
              parentClassName={inputEmailError && 'mdn-Input--attentionField'}
              value={confirmEmail}
              autoComplete="new-password"
            >
              Confirmar E-mail
            </Input>
          </div>
          <div className={styles.FormInput}>
            <Input
              required
              password
              name="password"
              onChange={(e) => setPassword(e.target.value)}
              hasError={inputPasswordError ? true : false}
              errorMessage={
                inputPasswordErrorMessage ? inputPasswordErrorMessage : ''
              }
              parentClassName={
                inputPasswordError && 'mdn-Input--attentionField'
              }
              value={password}
              autoComplete="new-password"
            >
              Senha
            </Input>
          </div>

          <Button
            block
            submit="true"
            className={styles.FormButtonSubmit}
            disabled={name && email && confirmEmail && password ? false : true}
          >
            Cadastrar
          </Button>
          <Link to="/login" className={styles.Link}>
            <Button block secondary>
              Login
            </Button>
          </Link>
        </form>
      )}

      {step === 2 && (
        <div>
          <Text className={styles.FormHeader}>
            Enviamos um código para seu email. <br />
            Insira no campo abaixo.
          </Text>
          <form
            autoComplete="new-password"
            onSubmit={handleSubmitConfirmationSignUp}
          >
            <div className={styles.FormInput}>
              <Input
                required
                text
                name="code"
                onChange={(e) => setCode(e.target.value)}
                hasError={inputCodeError ? true : false}
                errorMessage={
                  inputCodeErrorMessage ? inputCodeErrorMessage : ''
                }
                parentClassName={inputCodeError && 'mdn-Input--attentionField'}
                value={code}
                autoComplete="new-password"
              >
                Código
              </Input>
            </div>

            <Button
              block
              submit="true"
              className={styles.FormButton}
              disabled={code ? false : true}
            >
              Enviar
            </Button>

            <LinkMD
              inverse
              className={styles.LinkResendCode}
              onClick={handleResendSignUp}
            >
              Reenviar código
            </LinkMD>
          </form>
        </div>
      )}
    </AuthLayout>
  );
}

export default Register;
